import { render, staticRenderFns } from "./WidgetMetadataRecords.vue?vue&type=template&id=55a937ee&"
import script from "./WidgetMetadataRecords.vue?vue&type=script&lang=js&"
export * from "./WidgetMetadataRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetMetadataRecords.vue"
export default component.exports